import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';

const MailingList = () => {
    // VARIABLES

    const base_url = process.env.REACT_APP_BASE_URL;
    const [emails, setEmails] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [sortOrder, setSortOrder] = useState('asc');
    const [deletePending, setDeletePending] = useState(false)
    const [addPending, setAddPending] = useState(false)
    const [mailingPending, setMailingPending] = useState(false)

    // State for the new email
    const [newEmail, setNewEmail] = useState("");

    //variables for paginate
    const sortedEmails = sortOrder === 'asc' ? [...emails] : [...emails].reverse();
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = sortedEmails.slice(indexOfFirstItem, indexOfLastItem);
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    //INTERCEPTOR
    // Create an instance of Axios
    const api = axios.create({
        baseURL: `${base_url}`
    });

    // Set the authorization token for all requests
    api.interceptors.request.use((config) => {
        // Add your authorization token logic here
        const token = sessionStorage.getItem('token');
        config.headers.Authorization = `Bearer ${token}`;
        return config;
    });

    // FUNCTIONS

    const deleteEmailSuccess = (msg) =>
        toast.success(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });
    const deleteEmailError = (msg) =>
        toast.error(msg, {
            position: 'top-right',
            autoClose: 1500,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'light',
        });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setMailingPending(true)
        try {
            const response = await api.get(`${base_url}/mailing-list/get-all-emails/`);
            setEmails(response.data.result);
            setMailingPending(false)
        } catch (error) {
            console.log(error);
            deleteEmailError("An error occurred while trying to fetch email data");
        }
    };

    const handleDelete = (id) => {
        setDeletePending(true)
        api
            .post(`${base_url}/mailing-list/delete/${id}`)
            .then(function (response) {
                console.log(response.data);
                fetchData();
                deleteEmailSuccess("Email record was successfully deleted");
                setDeletePending(false)
            })
            .catch(function (error) {
                console.log(error.response.data.message);
            });
    };

    const toggleSortOrder = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        setSortOrder(newSortOrder);
    };

    const addEmailSuccess = (msg) =>
        toast.success(msg, {
            position: "top-right",
            autoClose: 1800,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light"
        });
    const handleSubmit = (event) => {
        event.preventDefault();
        setAddPending(true)

        api.post(`${base_url}/mailing-list/add-email/`, {
            "email": newEmail
        })
            .then(function (response) {
                console.log(response.data);
                setNewEmail("");
                addEmailSuccess("Email Entry was successfully added");
                fetchData();
                setAddPending(false)
            })
            .catch(function (error) {
                console.log(error.response.data.message);
            });
    }

    // Added by VM

    // navigation options
    const nextPage = () => {
        if (currentPage < Math.ceil(sortedEmails.length / itemsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const firstPage = () => {
        setCurrentPage(1);
    };

    const lastPage = () => {
        setCurrentPage(Math.ceil(sortedEmails.length / itemsPerPage));
    };

    const pageButtons = () => {
        const totalPages = Math.ceil(sortedEmails.length / itemsPerPage);
        const buttons = [];

        // Display up to 3 page numbers ahead of the current page
        for (let i = currentPage; i <= currentPage + 2 && i <= totalPages; i++) {
            buttons.push(
                <button
                    key={i}
                    className={`btn-pagination ${currentPage === i ? 'active-page' : ''}`}
                    onClick={() => setCurrentPage(i)}
                >
                    {i}
                </button>
            );
        }

        return buttons;
    };
    // end navigation options

    // JSX
    return (
        <>
            <div>
                <div className="d-flex my-1">
                    <div className="pt-3">
                        <h6 className="section-title">
                            <i className="bi bi-list"></i> MAILING LIST
                            <small className="text-secondary" style={{fontWeight:"400",fontSize:"smaller"}}> ({emails.length})</small>
                        </h6>
                    </div>
                    <div className="flex-fill text-end">
                        <button
                            className="btn-custom"
                            data-bs-toggle="modal"
                            data-bs-target="#add-email"
                        >
                            <i className="bi bi-plus-circle"></i> Add
                        </button>
                        <button className="btn-custom ms-1" onClick={toggleSortOrder}>
                            {sortOrder === 'asc' ? <div><i className="bi bi-sort-down"></i> Sort</div> : <div><i className="bi bi-sort-up"></i> Sort</div>}
                        </button>
                    </div>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped table-sm">
                        <thead className="table-dark">
                            <tr>
                                <th>ID</th>
                                <th>Email</th>
                                <th>Created At</th>
                                <th>Updated At</th>
                                <th>Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                mailingPending ? (
                                    <tr>
                                        <td colSpan="5" className="text-center">
                                            <div className="spinner-border spinner-border-lg text-custom my-3"></div>
                                        </td>
                                    </tr>
                                ) : (
                                    currentItems.map((item) => (
                                        <tr key={item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.email}</td>
                                            <td>{moment(item.createdAt).format('DD MMM YYYY h:mm:ss a')}</td>
                                            <td>{moment(item.updatedAt).format('DD MMM YYYY h:mm:ss a')}</td>
                                            <td>
                                                {
                                                    deletePending ? (
                                                        <button className="btn-custom-sm disabled-btn" disabled>
                                                            <i className="bi bi-trash"></i>
                                                        </button>

                                                    ) : (
                                                        <button className="btn-custom-sm" onClick={() => handleDelete(item.id)}><i className="bi bi-trash"></i></button>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    ))
                                )
                            }
                        </tbody>
                    </table>

                    {/* Added by VM */}
                    <div className="pagination btn-group">
                        <button
                            className="btn-pagination"
                            onClick={firstPage}
                            disabled={currentPage === 1}
                        >
                            First
                        </button>

                        <button
                            className="btn-pagination"
                            onClick={prevPage}
                            disabled={currentPage === 1}
                        >
                            <i className="bi-chevron-left"></i>
                        </button>

                        {/* page numbered buttons */}
                        {pageButtons()}

                        <button
                            className="btn-pagination"
                            onClick={nextPage}
                            disabled={currentPage === Math.ceil(sortedEmails.length / itemsPerPage)}
                        >
                            <i className="bi-chevron-right"></i>
                        </button>

                        <button
                            className="btn-pagination"
                            onClick={lastPage}
                            disabled={currentPage === Math.ceil(sortedEmails.length / itemsPerPage)}
                        >
                            Last
                        </button>
                    </div>
                </div>

                {/* <div className="pagination">
                    {Array.from({ length: Math.ceil(sortedEmails.length / itemsPerPage) }, (_, index) => (
                        <button
                            key={index}
                            className={`${currentPage === index + 1 ? 'active-pagination-btn' : 'pagination-btn'}`}
                            onClick={() => paginate(index + 1)}
                        >
                            {index + 1}
                        </button>
                    ))}
                </div> */}
            </div>

            <div className="modal fade" id="add-email">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title bold"><i className="bi bi-plus-circle"></i> Add Email</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <form onSubmit={handleSubmit}>
                                    <div className="input-group my-3">
                                        <span className="input-group-text input-group-text-custom"><i className="bi bi-envelope"></i></span>
                                        <input type="email" className="form-control custom-input-group" value={newEmail} onChange={(e) => setNewEmail(e.target.value)} placeholder="Email" required />
                                    </div>

                                    {
                                        addPending ? (
                                            <button type="submit" className="btn-custom w-100 disabled-btn" disabled>
                                                <span class="spinner-border spinner-border-sm"></span>
                                            </button>
                                        ) : (
                                            <button type="submit" className="btn-custom w-100">Submit</button>
                                        )
                                    }
                                </form>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn-gray-sm" data-bs-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MailingList;
